import { AsyncType, createAsyncTypes, createCRUDAsyncTypes } from "@ctra/utils";

const ns = "app/game-plans";

/**
 * Fetch game plans
 * @category Type
 */
const FETCH_GAME_PLAN_LIST = createAsyncTypes(ns, "FETCH_GAME_PLAN_LIST", { primary: "farmID" });

/**
 * CRUD game plan
 */
const [
  /**
   * @category Type
   */
  CREATE_GAME_PLAN,
  /**
   * @category Type
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _FETCH_GAME_PLAN,
  /**
   * @category Type
   */
  UPDATE_GAME_PLAN,
  /**
   * @category Type
   */
  DELETE_GAME_PLAN
]: Array<AsyncType> = createCRUDAsyncTypes(ns, "GAME_PLAN", { primary: "id" });

/**
 * CRUD to-do list
 */
const [
  /**
   * @category Type
   */
  CREATE_TODO_LIST,
  /**
   * @category Type
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _FETCH_TODO_LIST,
  /**
   * @category Type
   */
  UPDATE_TODO_LIST
]: Array<AsyncType> = createCRUDAsyncTypes(ns, "TODO_LIST", {
  primary: "gamePlanID"
});

/**
 * Update a single task
 */
const UPDATE_TASK = createAsyncTypes(ns, "UPDATE_TASK", { primary: "id" });

export default {
  FETCH_GAME_PLAN_LIST,

  CREATE_GAME_PLAN,
  UPDATE_GAME_PLAN,
  DELETE_GAME_PLAN,

  CREATE_TODO_LIST,
  UPDATE_TODO_LIST,
  UPDATE_TASK
};
